import { LoadingButton } from "@mui/lab";
import {
  Button,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import { useRouter } from "next/router";
import { useSnackbar } from "notistack";
import React from "react";
import { StyledTextField } from "../../pages/login";
import { editIntroductionSchema } from "../../schema";
import { useUpdateIntroductionMutation } from "../../services/profileAPI";
import { CustomDialogTitle } from "../../ui";

type editIntroductionPropsType = {
  introduction: string;
  onClose: () => void;
};

function EditIntroductionDialog({
  introduction,
  onClose,
}: editIntroductionPropsType) {
  const { enqueueSnackbar } = useSnackbar();
  const router = useRouter();
  const [updateIntroduction] = useUpdateIntroductionMutation();

  const formik = useFormik({
    initialValues: {
      introduction,
    },
    validationSchema: editIntroductionSchema,
    onSubmit: async (values) => {
      try {
        await updateIntroduction(values.introduction).unwrap();
        enqueueSnackbar("updated your introduction", {
          variant: "success",
        });
        onClose();
      } catch (error) {
        console.error(error);
        enqueueSnackbar("failed to update your introduction", {
          variant: "error",
        });
      }
    },
  });

  return (
    <>
      <CustomDialogTitle onClose={onClose}>
        <Typography>edit introduction</Typography>
      </CustomDialogTitle>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent dividers>
          <FormControl fullWidth variant="standard">
            <InputLabel shrink htmlFor="name" disableAnimation>
              introduction
            </InputLabel>
            <StyledTextField
              id="introduction"
              name="introduction"
              fullWidth
              multiline
              rows={4}
              placeholder="enter your introduction"
              value={formik.values.introduction}
              onChange={formik.handleChange}
              error={
                formik.touched.introduction &&
                Boolean(formik.errors.introduction)
              }
              helperText={
                Boolean(formik.touched.introduction) && (
                  <>{formik.errors.introduction}</>
                )
              }
              sx={{ mb: 1 }}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            cancel
          </Button>
          <LoadingButton
            variant="text"
            type="submit"
            loading={formik.isSubmitting}
          >
            update
          </LoadingButton>
        </DialogActions>
      </form>
    </>
  );
}

export default EditIntroductionDialog;
